// Auto-generate a workout name for the History timeline when an athlete
// finishes a timed block without giving it a custom title.
//
// Examples (block title falsy, today = 2026-05-13):
//   • metcon, rounds: 3                    → "3RFT 05132026"
//   • metcon, rep_scheme: [21, 15, 9]      → "21-15-9 05132026"
//   • metcon, time_cap_seconds only        → "For Time 05132026"
//   • amrap,  time_cap_seconds: 1200       → "AMRAP20 05132026"
//   • emom,   total_seconds:    900        → "EMOM15 05132026"
//   • tabata                               → "Tabata 05132026"
//   • ladder                               → "Ladder 05132026"

const pad = (n) => String(n).padStart(2, "0");

/** Format a Date as MMDDYYYY (no separators) — matches user spec. */
function fmtUSDate(date = new Date()) {
  return `${pad(date.getMonth() + 1)}${pad(date.getDate())}${date.getFullYear()}`;
}

function minutesOf(seconds) {
  if (!seconds || seconds <= 0) return null;
  return Math.round(seconds / 60);
}

/**
 * Compute a name for a block result. Returns `block.title` if the coach set one,
 * otherwise generates a sensible default from the block type + scheme.
 */
export function autoBlockName(block, date = new Date()) {
  const title = (block?.title || "").trim();
  if (title) return title;
  const stamp = fmtUSDate(date);
  const cfg = block?.scheme_config || {};
  const type = block?.type;

  if (type === "metcon") {
    if (Array.isArray(cfg.rep_scheme) && cfg.rep_scheme.length) {
      return `${cfg.rep_scheme.join("-")} ${stamp}`;
    }
    if (cfg.rounds && cfg.rounds > 0) {
      return `${cfg.rounds}RFT ${stamp}`;
    }
    return `For Time ${stamp}`;
  }
  if (type === "amrap") {
    const mins = minutesOf(cfg.time_cap_seconds);
    return `AMRAP${mins ? mins : ""} ${stamp}`.replace(/\s+/g, " ").trim();
  }
  if (type === "emom") {
    const mins = minutesOf(cfg.total_seconds || cfg.time_cap_seconds);
    return `EMOM${mins ? mins : ""} ${stamp}`.replace(/\s+/g, " ").trim();
  }
  if (type === "tabata") return `Tabata ${stamp}`;
  if (type === "intervals") return `Intervals ${stamp}`;
  if (type === "ladder") return `Ladder ${stamp}`;
  // Fallback — strength / superset wouldn't normally hit this code path.
  return `${(type || "Workout").toUpperCase()} ${stamp}`;
}
